// Both the generated API type and the billing page's own one.
export type PaymentMethodLike =
  | {
      type?: string;
      data?: {
        brand?: string;
        bank_name?: string;
        last4?: string;
        exp_month?: number;
        exp_year?: number;
      };
    }
  | null
  | undefined;

/**
 * What tells one saved payment method from another, as far as billing
 * shows it (no Stripe id comes with it), null without one. The same card
 * entered again reads the same.
 */
export const paymentMethodSignature = (paymentMethod: PaymentMethodLike) => {
  const data = paymentMethod?.data;

  if (!data) return null;

  return [
    paymentMethod.type,
    data.brand ?? data.bank_name,
    data.last4,
    data.exp_month,
    data.exp_year,
  ].join(":");
};
